import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import organization from '../content/organization.json';
import { Building2, Mail, Shield, FileText, Phone, MapPin } from 'lucide-react';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <Navigation />
      
      {/* Bouton Retour */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <BackButton to="/" label="Retour à l'accueil" />
      </div>

      <div className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-indigo-900 mb-8 text-center">
            Mentions Légales
          </h1>
          
          <Card className="shadow-xl">
            <CardContent className="p-4 md:p-8">
              <div className="prose prose-lg max-w-none">
                
                {/* Section 1 - Éditeur */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <Building2 className="h-6 w-6 text-amber-500" />
                    1. ÉDITEUR DU SITE
                  </h2>
                  <p className="mb-3">Le présent site est édité par :</p>
                  <div className="bg-indigo-50 p-6 rounded-lg mb-4 border-l-4 border-indigo-600">
                    <ul className="space-y-2 list-none">
                      <li><strong className="text-indigo-900">{organization.legalName}</strong> — Nom commercial : {organization.name}</li>
                      <li>{organization.legalForm}</li>
                      <li>Capital initial prévu par les statuts du <time dateTime={organization.initialCapitalAsOf}>10 août 2026</time> : <strong>{organization.initialCapital.toLocaleString('fr-FR')} €</strong></li>
                      <li>Valeur nominale d’une part sociale : <strong>{organization.shareNominal.toLocaleString('fr-FR')} €</strong></li>
                  <li>N° TVA intracommunautaire : <strong>FR34903459139</strong></li>
                      <li>SIREN : <strong>{organization.siren}</strong></li>
                      <li className="flex items-start gap-2">
                        <MapPin className="h-4 w-4 text-amber-500 mt-1 flex-shrink-0" />
                        <span><strong>Siège social :</strong> {organization.streetAddress}, {organization.postalCode} {organization.locality} – {organization.region} (France)</span>
                      </li>
                      <li>RNE / RCS : <strong>Pointe-à-Pitre</strong></li>
                      <li>Représentée par sa Présidente : <strong>Madame Félixia Vanessa PIPEROL</strong></li>
                    </ul>
                    <div className="mt-4 pt-4 border-t border-indigo-200">
                      <p className="font-semibold text-indigo-900 mb-2">Contact :</p>
                      <div className="space-y-2">
                        <div className="flex items-center gap-2">
                          <Mail className="h-4 w-4 text-amber-500" />
                          <span>Email : <a href={`mailto:${organization.contactEmail}`} className="text-indigo-600 hover:text-amber-500 font-medium">{organization.contactEmail}</a></span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Phone className="h-4 w-4 text-amber-500" />
                          <span>Téléphone : <a href={`tel:${organization.phone}`} className="text-indigo-600 hover:text-amber-500 font-medium">05 90 46 05 21</a></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Section 2 - Directeur de publication */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <FileText className="h-6 w-6 text-amber-500" />
                    2. DIRECTEUR DE PUBLICATION
                  </h2>
                  <p><strong>Madame Félixia Vanessa PIPEROL</strong>, Présidente de la SCIC OSO.</p>
                </div>

                {/* Section 3 - Hébergeur */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 flex items-center gap-2 mb-4">
                    <Shield className="h-6 w-6 text-amber-500" />
                    3. HÉBERGEUR DU SITE
                  </h2>
                  <p className="mb-3">Le site est hébergé par :</p>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <ul className="space-y-1 list-none">
                <li><strong>Emergent Labs Inc.</strong></li>
                <li>2380 Via Espada, Pleasanton, CA 94566, États-Unis</li>
                <li>Contact : <a href="mailto:support@emergent.sh" className="text-indigo-600 hover:text-amber-500">support@emergent.sh</a></li>
                <li>Site web : <a href="https://emergent.sh" className="text-indigo-600 hover:text-amber-500">https://emergent.sh</a></li>
                    </ul>
                  </div>
                </div>

                {/* Section 4 - Propriété intellectuelle */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                    4. PROPRIÉTÉ INTELLECTUELLE
                  </h2>
                  <p className="mb-4">L'ensemble des contenus présents sur le site (textes, images, logos, documents, vidéos, graphismes, données, supports de formation, éléments visuels et techniques) sont la propriété exclusive de :</p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li><strong>SCIC SAS OBJECTIF SCOP OUTREMER</strong></li>
                    <li>Et/ou de ses entités coopératives partenaires dûment identifiées</li>
                  </ul>
                  <div className="mt-4 p-4 bg-amber-50 border-l-4 border-amber-500 rounded">
                    <p className="text-sm font-medium text-amber-900">⚠️ Toute reproduction, représentation, modification, diffusion ou exploitation, même partielle, est strictement interdite sans autorisation écrite préalable.</p>
                  </div>
                </div>

                {/* Section 5 - RGPD */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                    5. DONNÉES PERSONNELLES (RGPD)
                  </h2>
                  <p className="mb-4">Conformément au Règlement Général sur la Protection des Données (RGPD – 2016/679) et à la Loi Informatique et Libertés modifiée, la SCIC OSO assure la protection et la confidentialité des données personnelles collectées.</p>
                  
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-xl font-semibold text-indigo-800 mb-2">5.1 Responsable du traitement</h3>
                      <div className="bg-indigo-50 p-4 rounded">
                        <p>SCIC SAS OBJECTIF SCOP OUTREMER</p>
                        <p>Email : <a href="mailto:dpo@objectifscopoutremer.com" className="text-indigo-600 hover:text-amber-500 font-medium">dpo@objectifscopoutremer.com</a></p>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-xl font-semibold text-indigo-800 mb-2">5.2 Finalités des traitements</h3>
                      <p className="mb-2">Les données collectées via le site sont utilisées pour :</p>
                      <ul className="list-disc list-inside space-y-1 ml-4">
                        <li>la gestion des comptes utilisateurs</li>
                        <li>l'accès aux services coopératifs</li>
                        <li>la mise en relation avec les établissements et partenaires</li>
                        <li>la gestion des demandes</li>
                        <li>la formation, l'accompagnement et le groupement d'employeurs</li>
                        <li>l'amélioration de la navigation et des services</li>
                      </ul>
                      <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded">
                        <p className="text-sm font-medium text-green-900">✓ Aucune donnée n'est vendue ni cédée à des fins commerciales.</p>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-xl font-semibold text-indigo-800 mb-2">5.3 Vos droits</h3>
                      <p className="mb-2">En application du RGPD, chaque utilisateur dispose des droits :</p>
                      <ul className="list-disc list-inside space-y-1 ml-4">
                        <li>d'accès</li>
                        <li>de rectification</li>
                        <li>d'effacement</li>
                        <li>de limitation</li>
                        <li>d'opposition</li>
                        <li>de portabilité</li>
                      </ul>
                      <p className="mt-3">Pour exercer ces droits : <a href="mailto:dpo@objectifscopoutremer.com" className="text-indigo-600 hover:text-amber-500 font-medium">dpo@objectifscopoutremer.com</a></p>
                    </div>
                  </div>
                </div>

                {/* Section 6 - Cookies */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                    6. COOKIES
                  </h2>
                  <p className="mb-3">Le site peut utiliser des cookies pour améliorer l'expérience utilisateur.</p>
                  <div className="bg-gray-50 p-4 rounded">
                    <p className="font-semibold mb-2">Types de cookies :</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li>cookies techniques indispensables</li>
                      <li>cookies de mesure d'audience</li>
                      <li>cookies fonctionnels</li>
                    </ul>
                  </div>
                  <p className="mt-3 text-sm text-gray-600">L'utilisateur peut gérer ses préférences via le bandeau cookies.</p>
                </div>

                {/* Section 7 - Responsabilité */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                    7. RESPONSABILITÉ
                  </h2>
                  <p className="mb-3">La SCIC OSO ne peut être tenue responsable de :</p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>l'utilisation incorrecte du site</li>
                    <li>l'indisponibilité temporaire liée à des opérations de maintenance</li>
                    <li>le contenu des sites externes pointant vers ce site</li>
                  </ul>
                  <p className="mt-4 text-sm italic text-gray-700">Aucune information présente sur ce site ne constitue un conseil financier, assurantiel ou juridique.</p>
                </div>

                {/* Section 8 - Relation COPPAM */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                    8. COPPAM, FOGEDOM ET ORGANISATION DE L’ÉCOSYSTÈME
                  </h2>
                  <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-600">
                    <p className="mb-3">Le site d’OBJECTIF SCOP OUTREMER présente les services de la SCIC et les actions menées avec ses partenaires.</p>
                    <ul className="space-y-2 list-none">
                      <li>✓ OBJECTIF SCOP OUTREMER est l’éditeur de ce site.</li>
                      <li>✓ COPPAM et FOGEDOM associatif interviennent comme partenaires, dans le cadre des conventions applicables.</li>
                      <li>✓ Chaque partenaire juridiquement distinct conserve sa personnalité morale, ses comptes, ses responsabilités et ses obligations propres.</li>
                      <li>✓ FOGEDOM-SCIC est un fonds interne d’OBJECTIF SCOP OUTREMER, constitué en section analytique sans personnalité juridique distincte.</li>
                    </ul>
                    <div className="mt-4 p-3 bg-amber-100 border border-amber-300 rounded">
                      <p className="text-sm font-semibold text-amber-900">Organisation prévue aux articles 36 à 39 des statuts adoptés le 10 août 2026. Les conditions propres à chaque service précisent les rôles et les modalités d’intervention.</p>
                    </div>
                  </div>
                </div>

                {/* Section 9 - Copyright */}
                <div className="mb-8 pb-6 border-b border-gray-200">
                  <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                    9. COPYRIGHT
                  </h2>
                  <div className="bg-gray-100 p-4 rounded text-center">
                    <p className="text-lg font-semibold">© 2026 – SCIC SAS OBJECTIF SCOP OUTREMER</p>
                    <p className="text-sm mt-2">Tous droits réservés. Reproduction interdite sans autorisation.</p>
                  </div>
                </div>

                {/* Section 10 - Contact */}
                <div className="mb-4">
                  <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                    10. CONTACT
                  </h2>
                  <div className="space-y-3">
                    <p className="flex items-center gap-2">
                      <Mail className="h-5 w-5 text-amber-500" />
                      <span>Pour toute information : <a href={`mailto:${organization.contactEmail}`} className="text-indigo-600 hover:text-amber-500 font-medium">{organization.contactEmail}</a></span>
                    </p>
                    <p className="flex items-center gap-2">
                      <Shield className="h-5 w-5 text-amber-500" />
                      <span>Pour toute demande RGPD : <a href="mailto:dpo@objectifscopoutremer.com" className="text-indigo-600 hover:text-amber-500 font-medium">dpo@objectifscopoutremer.com</a></span>
                    </p>
                  </div>
                </div>

              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default MentionsLegalesPage;
